<div class="eu-display_flex eu-column" style="gap: 0.625rem">
    <div class="emd-container search-bar-container" [ngStyle]="{ 'max-width': width.toString() + 'px' }">
        <div class="emd-container__content eu-display_flex eu-align-items_center" style="gap: 0.625rem; position: relative">
            <div class="filter-input eu-display_flex eu-column w-100" style="gap: 0.5rem; position: relative">
                <div class="eu-display_flex eu-align-items_center eu-justify_space-between">
                    <div class="eu-display_flex eu-align-items_center" style="gap: 0.375rem">
                        <i class="fa fa-search fa-lg" aria-hidden="true"></i>
                        <span class="emd-text _color_subtle search-label">Buscar por {{ currentFilter ? currentFilter.label : '' }}</span>
                    </div>
                    <div class="toggle-container">
                        <i
                            [attr.data-cy]="'search-bar-toggle'"
                            class="fa fa-angle-down fa-lg eu-cursor_pointer _color_subtle"
                            aria-hidden="true"
                            (click)="handleToggleFilters()"
                        ></i>
                    </div>
                </div>
                <div class="emd-container toggle-body" *ngIf="isOpen" #dropdown>
                    <app-search-options
                        [filters]="filters"
                        [selectedFilterType]="currentFilter?.type || ''"
                        (onOptionChange)="onOptionChange($event)"
                    ></app-search-options>
                </div>
            </div>
            <div
                *ngIf="currentFilter && !currentFilter?.optionList"
                class="filter-input eu-display_flex eu-align-items_center eu-justify_space-between w-100"
            >
                <input
                    [attr.data-cy]="'search-bar-text-input'"
                    *ngIf="!currentFilter?.inputType || currentFilter?.inputType === 'text'"
                    [placeholder]="getSearchPlaceholder()"
                    class="search-input"
                    type="text"
                    autocomplete="off"
                    [(ngModel)]="currentSearchValue"
                    [mask]="currentFilter.mask ? currentFilter.mask : null"
                />
                <input
                    [attr.data-cy]="'search-bar-date-input'"
                    *ngIf="currentFilter?.inputType && currentFilter?.inputType === 'date'"
                    [placeholder]="getSearchPlaceholder()"
                    class="search-input"
                    type="date"
                    autocomplete="off"
                    [(ngModel)]="currentSearchValue"
                    [mask]="currentFilter.mask ? currentFilter.mask : null"
                />
            </div>
            <div class="w-100 search-select-container" *ngIf="currentFilter && currentFilter?.optionList">
                <div *ngIf="!currentFilter?.searchable" class="emd-select search-select">
                    <select [attr.data-cy]="'search-bar-options-select'" [(ngModel)]="currentSearchValue">
                        <option [value]="null" disabled selected hidden>
                            {{ currentFilter.placeholder }}
                        </option>
                        <option *ngFor="let option of currentFilter.optionList" [value]="option.id">
                            <span class="emd-text _color_subtle"> {{ option.name }}</span>
                        </option>
                    </select>
                    <div class="emd-select__arrow"></div>
                </div>

                <select-live-search
                    *ngIf="currentFilter.searchable"
                    [attributeNameOfContentObjectOnListToOutput]="'name'"
                    [list]="currentFilter.optionList"
                    [inputPlaceholder]="'Selecione'"
                    (getSelectedContent)="onSelectSearchableOption($event)"
                    [selectedContent]="currentOptionSelected?.name ?? undefined"
                    [controlName]="'search-bar-searchable-select'"
                ></select-live-search>
            </div>
            <ng-content select="left-side-actions"></ng-content>
            <button
                [attr.data-cy]="'search-bar-button'"
                class="emd-btn search-button"
                [disabled]="isFetchingData"
                [ngClass]="{ disabled: isFetchingData }"
                (click)="handleSearch()"
            >
                Buscar
            </button>

            @if (isFetchingData) {
                <div class="_loading">
                    <div class="spinner-border loading"></div>
                </div>
            }

            <i class="eu-mr_1 fa fa-times-circle-o fa-lg eu-cursor_pointer clear" aria-hidden="true" (click)="handleClear()"></i>
            <div>
                <ng-content></ng-content>
            </div>
        </div>
        <div *ngIf="useActionFooter" class="emd-container__footer">
            <ng-content select="footer-actions"></ng-content>
        </div>
    </div>
</div>
